import type {
  FilesStorageAzureSchemaPatched,
  FilesStorageB2SchemaPatched,
  FilesStorageFileSchemaPatched,
  FilesStorageGcsSchemaPatched,
  FilesStorageS3SchemaPatched,
} from '@iconik-io/iconik-api/src/schema_patched/files_storages';

import type { EditStorageForm } from './types';

export type StorageCloudOrIsg =
  | FilesStorageFileSchemaPatched
  | FilesStorageAzureSchemaPatched
  | FilesStorageGcsSchemaPatched
  | FilesStorageB2SchemaPatched
  | FilesStorageS3SchemaPatched;

export const isCloudOrIsgStorage = (
  value?: Partial<EditStorageForm>,
): value is StorageCloudOrIsg => {
  if (!value?.method) {
    return false;
  }
  return ['FILE', 'GCS', 'S3', 'B2', 'AZURE'].includes(value.method);
};

type StorageCloud =
  | FilesStorageAzureSchemaPatched
  | FilesStorageGcsSchemaPatched
  | FilesStorageB2SchemaPatched
  | FilesStorageS3SchemaPatched;

export const isCloudStorage = (
  value?: Partial<EditStorageForm>,
): value is StorageCloud => {
  if (!value?.method) {
    return false;
  }
  return ['GCS', 'S3', 'B2', 'AZURE'].includes(value.method);
};
